import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'CONTACT', {
  TITLE: 'Contact Us',
  DESCRIPTION:
    'If you have any questions or need assistance, please reach out to us through the following contact methods.',
  WHATSAPP_LABEL: 'WhatsApp Number:',
  FORM_SUCCESS: 'Your message has been sent successfully!',
  SUBJECT: 'Subject',
  MESSAGE: 'Message',
  SUBMIT_BUTTON: 'Submit',
  LOADING: 'Loading...',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'CONTACT', {
  TITLE: 'Contáctenos',
  DESCRIPTION:
    'Si tiene alguna pregunta o necesita asistencia, por favor contáctenos a través de los siguientes métodos de contacto.',
  WHATSAPP_LABEL: 'Número de WhatsApp:',
  FORM_SUCCESS: '¡Su mensaje ha sido enviado con éxito!',
  SUBJECT: 'Asunto',
  MESSAGE: 'Mensaje',
  SUBMIT_BUTTON: 'Enviar consulta',
  LOADING: 'Cargando...',
});
